var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-alert",
    {
      class: _vm.$attrs.class + " p-1 mb-0",
      attrs: { show: "", variant: "danger" },
    },
    [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.getMessages.summary) } }),
      _c("ul", [
        _vm.showCheckPaymentStatus
          ? _c(
              "li",
              [
                _vm._v(" " + _vm._s(_vm.getMessages.checkStatus) + " "),
                _c("e-button", {
                  staticStyle: { padding: "5px" },
                  attrs: {
                    id: _vm.$attrs.id + "-pix_message-btn_check_payment",
                    variant: "primary",
                    icon: "search",
                  },
                  on: {
                    click: function () {
                      return _vm.$emit("check-payment-status")
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm.showConfirmPayment
          ? _c(
              "li",
              [
                _vm._v(" " + _vm._s(_vm.getMessages.manualConfirm) + " "),
                _c("e-button", {
                  staticStyle: { padding: "5px" },
                  attrs: {
                    id: _vm.$attrs.id + "-pix_message-btn_confirm_payment",
                    variant: "primary",
                    icon: "check2-circle",
                  },
                  on: {
                    click: function () {
                      return _vm.$emit("confirm-payment")
                    },
                  },
                }),
                _vm._v(" " + _vm._s(_vm.getMessages.manualConfirmNote) + " "),
              ],
              1
            )
          : _vm._e(),
        _vm.showDelete
          ? _c(
              "li",
              [
                _vm._v(" " + _vm._s(_vm.getMessages.delete) + " "),
                _c("e-button", {
                  staticStyle: { padding: "5px" },
                  attrs: {
                    id: _vm.$attrs.id + "-pix_message-btn_delete",
                    tabindex: "-1",
                    variant: "danger",
                    icon: "trash",
                  },
                  on: {
                    click: function () {
                      return _vm.$emit("delete")
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("p", { domProps: { innerHTML: _vm._s(_vm.getMessages.resume) } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }